import {
  DEFAULT_KEYCLOAK_CLIENT_ROLE,
  isKeycloakClientRole,
  KEYCLOAK_CLIENT_ROLES,
  type KeycloakClientRole,
} from '../../auth/clientRoles';

/** Client roles used by LIKS / LAC. */
export const LAC_CLIENT_ROLES = KEYCLOAK_CLIENT_ROLES;

export type LacClientRole = KeycloakClientRole;

/** Roles that LAC operators may assign when creating or editing users. */
export const LAC_ASSIGNABLE_ROLES: readonly LacClientRole[] = [
  'ADMIN',
  'MEMBER',
];

export const DEFAULT_LAC_CLIENT_ROLE = DEFAULT_KEYCLOAK_CLIENT_ROLE;

/** Role options for edit: include LAC_ADMIN when already assigned. */
export function getLacEditRoleOptions(
  loadedRole: LacClientRole,
): readonly LacClientRole[] {
  return loadedRole === 'LAC_ADMIN' ? LAC_CLIENT_ROLES : LAC_ASSIGNABLE_ROLES;
}

export function isLacClientRole(value: string): value is LacClientRole {
  return isKeycloakClientRole(value);
}

/** Pick the highest-privilege known LAC role from an assigned role list. */
export function resolveLacClientRoleFromNames(
  roleNames: string[] | null | undefined,
): LacClientRole {
  const assigned = new Set(roleNames ?? []);
  for (const role of LAC_CLIENT_ROLES) {
    if (assigned.has(role)) {
      return role;
    }
  }
  return DEFAULT_LAC_CLIENT_ROLE;
}
